import DimensionsManagement from 'features/dimensions';
import React from 'react';

const DimensionsManagementPage = (): React.ReactElement => {
  return <DimensionsManagement />;
};

export default DimensionsManagementPage;
